import type { Config } from '@puckeditor/core';

import { standalonePagePuckConfig } from '../standalone-page/puck-config';
import { PageRootRender } from '../components/page-root-render';
import { createProductionComponents } from '../components/production-components';

/**
 * Production Puck config for rendering published standalone pages.
 * Reuses all editor component definitions with the PageRootRender root
 * to handle header/navigation from page-level settings.
 */
export const standalonePageRenderConfig: Config = {
  ...standalonePagePuckConfig,
  components: createProductionComponents(standalonePagePuckConfig.components),
  root: {
    ...standalonePagePuckConfig.root,
    render: PageRootRender,
  },
};
